import { render } from "./UploadTokoList.vue?vue&type=template&id=b932c2a2&scoped=true"
import script from "./UploadTokoList.vue?vue&type=script&lang=js"
export * from "./UploadTokoList.vue?vue&type=script&lang=js"

import "./UploadTokoList.vue?vue&type=style&index=0&id=b932c2a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b932c2a2"

export default script